export default __webpack_public_path__ + "static/media/sharethis-overview.png";